export default __webpack_public_path__ + "static/NotoSansJP-Regular-36dfa43ca2068ced0078458966d5c861.woff";